export default {
  newDesign: true,
  parameters: {
    segment: 3,
    landing_id: "EnQRUK",
  },

  title:
    "Answer 4 questions and get a free Roblox coding class for your child | Kodland",
  downtimeUrl: "https://www.kodland.org/",
  startPage: {
    title:
      "Answer 4 questions and get a free Roblox coding class for your child",
    subtitle:
      "In 60 minutes, your child will learn the basics of Roblox game design with a personal tutor and build their first mini-project",
    image: {
      url: "/welcome/uk_roblox_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/uk_roblox_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Let's start 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title:
      "Thank you for your interest in Kodland. Our online courses are designed for children aged 8 to 17.",
    subtitle:
      "Please note that our courses require a keyboard and mouse; therefore, phones, tablets, and devices without these features are not compatible.<br>If you do have a laptop, please resubmit the form via this link <a target=\"_blank\" href=\"https://mrqz.me/66c7170aca95fe0026c5a69c?roistat_visit=9376\">this link</a>, or contact us at +447700182949💙",
  },
  quizRotateBySteps: {
    1: {
      question: "How does your child spend his/her free time?",
      answers: [
        "🎨 Likes arts: drawing, music, acting",
        "🎮 Plays video games — especially Roblox",
        "🧩 Plays board games",
        "🏅 My child likes sports",
        "📺 Watches cartoons and movies",
        "👥 Goes out with friends",
      ],
    },
    2: {
      question: "Why would you like to enrol your child in coding classes?",
      answers: [
        "🎮 My child plays Roblox a lot — why not learn to create in it?",
        "😜 My child always watches YouTube or TikTok",
        "💡 My child wants to become a coder",
        "❓ Other",
      ],
    },
    3: {
      title: "How old is your child?",
      type: "age",
      button: "",
    },
    4: {
      question: "Do you have a computer or laptop for studying?",
      answers: [
        "💚 Yes",
        {
          answer: "❤️ No",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "Just one step left 🎉",
      typeInfo: "congrats",
      subtitle:
        "Unlock your child's creative potential in coding and digital creation!",
      button: "📅 Schedule a lesson",
    },
    6: {
      title: "Sign up for a class",
      type: "one-page-contacts",
      subtitle:
        "Let’s get to know each other, find out what we will learn, and how the lessons will be conducted.",
      button: "👏 Great. The final step!",
    },
    7: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    8: {
      title: "Check out this information to complete the registration ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Please ensure you have a working computer or laptop available for the lesson. It’s also important that you accompany your child during the class. Each session is personalized and tailored to your child's needs.",
      button: "What else?",
    },
    9: {
      title: "Before the class, check your email and WhatsApp for updates 📞",
      typeInfo: "whatsapp",
      subtitle:
        "We'll send you a reminder 24 hours before the class and will request confirmation of your attendance 2 hours prior to the start time. Staying in touch is essential to avoid class cancellation.",
      button: "Great!",
    },
    10: {
      title: "The lesson will take place on our platform 💻",
      typeInfo: "classroom",
      subtitle:
        "You'll get a link and a unique code via WhatsApp and email. Just click the link, it will take you straight to the lesson. No extra apps, no downloads.",
      button: "Got it ✅",
    },
  },
};
